import { ErrorPage } from '~/components/ErrorPage';
import { PageWrapper } from '~/components/PageWrapper';

export default function NotFound() {
  return (
    <PageWrapper>
      <ErrorPage type="Not_Found" />
    </PageWrapper>
  );
}
